import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from "html-react-parser";
import { services } from "constants/services";
import { AccordionGeneral } from "components/accordion";

import Others from "assets/images/hero-images/Banner_Others.png";
import BG from "assets/images/hero-images/BG.png";

function ChequeDeposit() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Services"
          title={`<span className="jumbotron-subtitle-2">Cheque Deposit</span> Services`}
          backgroundImage={Others}
          uniqueBg={BG}
        />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col md={4}>
              <h2>{services.chequeDeposit.about.title}</h2>
            </Col>
            <Col md={8}>{parse(services.chequeDeposit.about.description)}</Col>
          </Row>
          <Row className="my-5">
            <Col>
              <AccordionGeneral list={services.chequeDeposit.accordion} />
            </Col>
          </Row>
          <Row className="py-4">
            <Col>
              <p>
                <strong>
                  Note: Please ensure that you write down the following details
                  on the back of each cheque before dropping the cheque:
                </strong>
              </p>
              <ul>
                <li>Name</li>
                <li>Contact Number</li>
                <li>15 digit account number</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default ChequeDeposit;
